<!-- Confirmation Dialog Component -->
<div class="confirm-dialog-container">
  
  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-content">
    <div class="dialog-layout">
      
      <!-- Icon Section -->
      <div class="dialog-icon-wrapper">
        <div class="dialog-icon">
          <mat-icon class="icon">
            {{ data.icon || 'warning' }}
          </mat-icon>
        </div>
      </div>
      
      <!-- Text Content Section -->
      <div class="dialog-text">
        <h1 
          mat-dialog-title 
          class="dialog-title">
          {{ data.title || 'Confirmation' }}
        </h1>
        
        <!-- Interpolated, never [innerHTML]: several callers build this string from names typed
             by a parent in the family app, which a school admin then reads here. -->
        <p class="dialog-message">{{ data.message }}<ng-container *ngIf="data.emphasis"><b>{{ data.emphasis }}</b>{{ data.messageSuffix }}</ng-container></p>
      </div>
      
    </div>
  </mat-dialog-content>
  
  <!-- Dialog Actions -->
  <mat-dialog-actions class="dialog-actions">
    
    <!-- Cancel Button -->
    <button 
      *ngIf="!data.hideCancelButton"
      mat-stroked-button 
      type="button"
      class="cancel-button"
      (click)="onCancel()">
      <mat-icon>close</mat-icon>
      {{ data.cancelText || 'Cancel' }}
    </button>
    
    <!-- Confirm Button -->
    <button 
      mat-flat-button 
      type="button"
      class="confirm-button"
      color="warn"
      (click)="onConfirm()">
      <mat-icon>check</mat-icon>
      {{ data.confirmText || 'Confirm' }}
    </button>
    
  </mat-dialog-actions>
  
</div>